let createModal = function (id, config) {
    const hasHeader = false;
    const hasFooter = false;

    const modal = document.createElement("div");
    const body = document.body;
    modal.setAttribute("id", id);
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("class", "modal micromodal-slide " + config.style);
    modal.innerHTML = `<div class="modal__overlay" tabindex="-1" data-micromodal-close data-overlay-screen>
            <div class="modal__container"
                role="dialog"
                aria-modal="true"
                aria-labelledby="${id}-title">
                <header class="modal__header">
                    <h2 class="modal__title" id="${id}-title">
                        Micromodal
                    </h2>
                    <button class="modal__close"
                        aria-label="Close modal"
                        data-micromodal-close>

                    </button>
                </header>
                <main class="modal__content" id="${id}-content">

                </main>
                <footer class="modal__footer">
                    <button class="modal__btn modal__btn-primary">
                        Continue
                    </button>
                    <button class="modal__btn"
                        data-micromodal-close
                        aria-label="Close this dialog window">
                        Close
                    </button>
                </footer>
            </div>
        </div>`;

    if (!hasHeader) {
        const header = modal.querySelector(".modal__header");
        header.remove();
    }
    if (!hasFooter) {
        const footer = modal.querySelector(".modal__footer");
        footer.remove();
    }
    body.appendChild(modal);
    return modal;
};
export { createModal };
